import { createProfessionalExporter } from '../../../utils/professionalExport';
import { formatCurrency } from '../packages/packageData';
import { getGymMemberId } from '../members/memberData';
import {
  membershipStartDisplay,
  membershipExpiryDisplay,
  membershipDateDisplay,
  membershipPaymentNoteDisplay,
} from '../../../utils/membershipDates';
import { PAYMENT_METHOD_OPTIONS, splitAmountForMethod } from '../../../utils/splitPaymentUtils';

const methodHeaders = PAYMENT_METHOD_OPTIONS.map((m) => m.label);

const headers = [
  'Entry Date',
  'Serial No',
  'Member',
  'Branch',
  'Package',
  'Duration',
  'Registration Fees',
  'Package Fees',
  'Amount Paid',
  ...methodHeaders,
  'Pending Amount',
  'Start Date',
  'Expiry Date',
  'Auto Renewal',
  'Payment Note',
  'Status',
];

function formatMembershipStatus(m) {
  if (m.lifetime) return 'Lifetime';
  if (m.frozen) return 'Frozen';
  if (m.status === 'expired') return 'Expired';
  return 'Active';
}

/** Same serial as membership table (ID-5493). */
function membershipSerialExport(m) {
  return getGymMemberId({
    serialNo: m?.serialNo ?? m?.serial_no,
    gym_member_id: m?.gym_member_id || m?.baseGymId,
    gymId: m?.gymId,
  }) || '—';
}

const exporter = createProfessionalExporter({
  title: 'Membership List',
  headers,
  slug: 'memberships',
  getRows: (list) =>
    list.map((m) => [
      membershipDateDisplay(m),
      membershipSerialExport(m),
      m.memberName || m.member || '—',
      m.branch || '—',
      m.package,
      m.duration || '—',
      formatCurrency(m.registrationFee || 0),
      formatCurrency(m.packageFee || 0),
      formatCurrency(m.totalPaid || 0),
      ...PAYMENT_METHOD_OPTIONS.map(({ key }) => {
        const amt = splitAmountForMethod(m, key);
        return amt > 0 ? formatCurrency(amt) : '—';
      }),
      formatCurrency(m.pendingAmount || 0),
      membershipStartDisplay(m),
      membershipExpiryDisplay(m),
      m.autoRenewal ? 'Yes' : 'No',
      membershipPaymentNoteDisplay(m),
      formatMembershipStatus(m),
    ]),
  getSummary: (list) => [
    `Total memberships: ${list.length}`,
    `Active: ${list.filter((m) => m.status === 'active' && !m.frozen).length}`,
  ],
});

export const printMembershipList = (data) => exporter.print(data);
export const exportMembershipCsv = (data) => exporter.csv(data);
export const exportMembershipExcel = (data) => exporter.excel(data);
export const exportMembershipPdf = (data) => exporter.pdf(data);
export const exportMemberships = (data) => exporter.export(data);
